import React, { useRef, useState, useEffect, useCallback } from "react";
import { fabric } from "fabric";
import { toast } from "react-toastify";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Utils from "../../../../utils";
import {
  getEnvelopeRequestSignDocumentPages,
  signPlaceholdersUpdate,
} from "../../../../services/CommonService";
import { EVERY_ONE_OBJECT, FONT_FAMILY_LIST, FONT_SIZE_LIST, DATEFORMAT_LIST } from "../../../../configs/AppConfig";
// import arrow from '../../../../assets/Images/arrow.png'


function MakeFillablePopup({
  makeFillable,
  signatureDocumentData,
  setLoading,
  formObj,
  setFormObj,
  handleMakeFillable,
}) {
  const animatedComponents = makeAnimated();
  const [signDocId, setSignDocId] = useState(0);
  const [signDocMode, setSignDocMode] = useState(null);
  const [canvas, setCanvas] = useState("");
  const [imageList, setImageList] = useState([]);
  const [docRecipients, setDocRecipients] = useState([]);
  const [requestSign, setRequestSign] = useState([]);
  const [assignToRecipient, setAssignToRecipient] = useState([]);
  const [showAnimation, setShowAnimation] = useState(true);
  const [animationCount, setAnimationCount] = useState(0);

  const [tempRecipient, setTempRecipient] = useState(""); // use in multiple sign mode

  const canvasRef = useRef();
  const clsFormButtonRef = useRef();
  const containerRef = useRef();
  const autoFillEditModeRef = useRef();


  const [draggedItemType, setDraggedItemType] = useState(null);

  const [noFieldSelectionFlag, setNoFieldSelectionFlag] = useState(true);
  const [signerSelectedBackgroundColor, setSignerSelectedBackgroundColor] =
    useState("d1ecf1");

  const [selectedFont, setSelectedFont] = useState("");
  const [selectedFontSize, setSelectedFontSize] = useState("");
  const [selectedDateFormat, setSelectedDateFormat] = useState("");
  const [selectedTextContent, setSelectedTextContent] = useState("");

  const [visibleFabricTools, setVisibleFabricTools] = useState(false);
  const [visibleDateFormatDropdown, setVisibleDateFormatDropdown] = useState(false);
  const [visibleTextContentTextarea, setVisibleTextContentTextarea] = useState(false);
  const [visibleAssignToDropdown, setVisibleAssignToDropdown] = useState(false);

  const [previewButtonText, setPreviewButtonText] = useState("Preview");
  const [fontLoaded, setFontLoaded] = useState(false);

  const debounceTimeout = useRef(null);

  // Reset animation state when component mounts or makeFillable changes
  useEffect(() => {
    if (makeFillable) {
      setShowAnimation(false);
      setAnimationCount(0);
    }

    // Cleanup function to reset animation state when component unmounts
    return () => {
      setShowAnimation(false);
      setAnimationCount(0);
    };
  }, [makeFillable]);

  // Animation Logic: Show animation 2 times and hide after 3-4 seconds
  useEffect(() => {
    if (!visibleFabricTools || !makeFillable) return;

    const animationDuration = 4000; // 4 seconds for each animation cycle
    const maxCycles = 2; // Show animation 2 times

    if (animationCount < maxCycles) {
      setShowAnimation(true);
      const timer = setTimeout(() => {
        setShowAnimation(false);
        setAnimationCount((prev) => prev + 1);
      }, animationDuration);

      return () => clearTimeout(timer);
    }
  }, [animationCount, makeFillable, visibleFabricTools]);

  // Reset animation when it completes a cycle
  useEffect(() => {
    if (!showAnimation && animationCount < 2) {
      const timer = setTimeout(() => {
        setShowAnimation(true);
      }, 500); // Small delay before restarting animation
      return () => clearTimeout(timer);
    }

    // After two cycles, stop animation and do not reset until popup is reopened
    if (animationCount >= 2) {
      setShowAnimation(false);
      // Do not reset animationCount here, so it doesn't restart
    }
  }, [showAnimation, animationCount]);



  const handleDragStart = (e, type) => {
    console.log("drag start " + type);

    // Prevent dragging if no signer is selected
    if (requestSign.length === 0) {
      e.preventDefault();
      toast.error("Please select at least one signer before adding signature fields");
      return;
    }

    setDraggedItemType(type);
  };

  const handleDragStop = (e) => {
    console.log("drag stop");

    var mousePosition = localStorage.getItem("mousePosition");
    mousePosition = JSON.parse(mousePosition);

    if (mousePosition !== null) {
      let backgroundColor = signerSelectedBackgroundColor;
      let leftPositionObject = mousePosition.x - 75;
      let topPositionObject = mousePosition.y - 25;

      const widthObject = 150;
      const heightObject = 50;
      const objId = generateId(draggedItemType);
      const requestRecipient = tempRecipient;
      const fontSize = "14";
      const fontFamily = "Arial";
      const textContent = "";
      const reRenderRightSidebar = true;

      fabricTool(
        backgroundColor,
        topPositionObject,
        leftPositionObject,
        widthObject,
        heightObject,
        objId,
        requestRecipient,
        fontSize,
        fontFamily,
        textContent,
        reRenderRightSidebar
      );
    }
  };

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      border: "1px solid #ccc",
      borderRadius: "0px",
      boxShadow: "none",
      "&:hover": {
        border: "1px solid #ccc",
      },
    }),
    valueContainer: (base) => ({
      ...base,
      fontSize: "16px",
      marginLeft: "4px",
      overflow: "visible",
      padding: "0px 8px",
    }),
    placeholder: (base) => ({
      ...base,
      position: "absolute",
    }),
  };

  let deleteIcon =
    "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Ebene_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='595.275px' height='595.275px' viewBox='200 215 230 470' xml:space='preserve'%3E%3Ccircle style='fill:%23F44336;' cx='299.76' cy='439.067' r='218.516'/%3E%3Cg%3E%3Crect x='267.162' y='307.978' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -222.6202 340.6915)' style='fill:white;' width='65.545' height='262.18'/%3E%3Crect x='266.988' y='308.153' transform='matrix(0.7071 0.7071 -0.7071 0.7071 398.3889 -83.3116)' style='fill:white;' width='65.544' height='262.179'/%3E%3C/g%3E%3C/svg%3E";

  let img = document.createElement("img");
  // img.src = deleteIcon;

  //Delete fabric object comman code.
  fabric.Object.prototype.transparentCorners = false;
  fabric.Object.prototype.cornerColor = "#0c5460";
  fabric.Object.prototype.cornerStyle = "circle";
  fabric.Object.prototype.cornerSize = 5;

  fabric.Object.prototype.controls.deleteControl = new fabric.Control({
    x: 0.5,
    y: -0.5,
    offsetY: 0,
    cursorStyle: "pointer",
    mouseUpHandler: function (eventData, transform) {
      console.log("Delete control clicked"); // Debug log
      deleteObject(eventData, transform);
    },
    render: renderIcon,
    cornerSize: 25,
  });

  let errorsObj = {
    recipients: "",
  };

  const [errors, setErrors] = useState(errorsObj);

  // const pdfWidth = 794;
  // const pdfHeight = 1123;

  // Dynamic
  // const pdfWidth = 595;
  // const pdfHeight = 842;

  const [pdfDimensions, setPdfDimensions] = useState({ width: 0, height: 0 });
  useEffect(() => {
    if (signatureDocumentData) {
      /*
      let incPercentage = 25;
      let { width, height } = signatureDocumentData?.dimensions;
      let incWidth = Math.round(width * incPercentage / 100);
      let incHeight = Math.round(height * incPercentage / 100);
      width = Math.round(width + incWidth);
      height = Math.round(height + incHeight);
      */
      let { width, height } = signatureDocumentData?.dimensions;
      setPdfDimensions({ width, height });
    }
  }, [signatureDocumentData]);

  useEffect(() => {
    if (!canvas && pdfDimensions.width && pdfDimensions.height) {
      const initCanvas = new fabric.Canvas('canv', {
        height: pdfDimensions.height,
        width: pdfDimensions.width,
      });
      setCanvas(initCanvas);
    } else if (canvas) {
      canvas.setDimensions({
        width: pdfDimensions.width,
        height: pdfDimensions.height,
      });
      canvas.renderAll();
    }
  }, [pdfDimensions, canvas]);



  /*
  const initCanvas = () =>
    new fabric.Canvas("canv", {
      height: window.innerHeight,
      width: pdfWidth
    });
  useEffect(() => {
    setCanvas(initCanvas());
  }, []);
  */

  useEffect(() => {
    const loadFont = async () => {
      try {
        const font = new FontFace('Playball', `url(${process.env.PUBLIC_URL}/fonts/Playball-Regular.ttf)`);
        await font.load();
        document.fonts.add(font);
        setFontLoaded(true);
      } catch (error) {
        console.error('Font failed to load, using fallback:', error);
        setFontLoaded(false); // Will trigger fallback to Arial
      }
    };

    loadFont();
  }, []);

  function storeMousePosition(x, y) {
    let position = {
      x: x,
      y: y,
    };
    localStorage.setItem("mousePosition", JSON.stringify(position));
  }

  /*
  useEffect(() => {
    const { width, height } = pdfDimensions;
    const dynamicHeight = imageList.length * (height + 25);   
    const handleScroll = () => {
      canvas.setDimensions({ width: width, height: dynamicHeight });
      canvas.renderAll();
    };

    const scrollableDiv = containerRef.current;
    scrollableDiv.addEventListener("scroll", handleScroll);

    return () => {
      scrollableDiv.removeEventListener("scroll", handleScroll);
    };
  }, [canvas, imageList, pdfDimensions]);
  */

  /*
  useEffect(() => {
    const { width, height } = pdfDimensions;
    const dynamicHeight = imageList.length * (height + 25);   
    
    const handleScroll = () => {
      const scrollableDiv = containerRef.current;
      const scrollTop = scrollableDiv.scrollTop;
      const windowHeight = scrollableDiv.clientHeight;
      const scrollHeight = scrollableDiv.scrollHeight;
  
      // Add a threshold to detect near-bottom scrolling
      const threshold = 100; // You can adjust this value as needed
  
      if (windowHeight + scrollTop >= scrollHeight - threshold) {
        console.log('User is near the bottom, loading more content');
        
        // Calculate new canvas height
        const newCanvasHeight = Math.min(dynamicHeight, scrollHeight + height);
        
        // Set new dimensions and render the canvas
        canvas.setDimensions({ width: width, height: newCanvasHeight });
        canvas.renderAll();
      }
    };
  
    const scrollableDiv = containerRef.current;
    scrollableDiv.addEventListener("scroll", handleScroll);
  
    return () => {
      scrollableDiv.removeEventListener("scroll", handleScroll);
    };
  }, [canvas, imageList, pdfDimensions]);
  */

  useEffect(() => {
    const { width, height } = pdfDimensions;
    const dynamicHeight = imageList.length * (height + 25);

    const handleScroll = () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      debounceTimeout.current = setTimeout(() => {
        const scrollableDiv = containerRef.current;
        const scrollTop = scrollableDiv.scrollTop;
        const windowHeight = scrollableDiv.clientHeight;
        const scrollHeight = scrollableDiv.scrollHeight;

        // Add a threshold to detect near-bottom scrolling
        const threshold = 100; // You can adjust this value as needed

        if (windowHeight + scrollTop >= scrollHeight - threshold) {
          console.log('User is near the bottom, loading more content');

          // Calculate new canvas height
          const newCanvasHeight = Math.min(dynamicHeight, scrollHeight + height);

          // Set new dimensions and render the canvas
          canvas.setDimensions({ width: width, height: newCanvasHeight });
          canvas.renderAll();
        }
      }, 200); // 200 ms debounce delay, adjust as needed
    };

    const scrollableDiv = containerRef.current;
    scrollableDiv.addEventListener("scroll", handleScroll);

    return () => {
      scrollableDiv.removeEventListener("scroll", handleScroll);
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, [canvas, imageList, pdfDimensions, containerRef]);


  const renderImageOnCanvas = useCallback(async () => {
    if (makeFillable === true && imageList.length > 0) {
      canvas.clear().renderAll();
      var pagePositionArr = [];

      var pdfWidth = pdfDimensions.width;
      var pdfHeight = pdfDimensions.height;
      canvas.setDimensions({ width: pdfWidth, height: pdfHeight });

      // var imgWidth = pdfWidth;
      var imgHeight = pdfHeight;

      let countImg = 1;
      for (var i = 0; i < imageList.length; i++) {
        var topMultiplier = countImg++ * 20;
        var top = ((i * imgHeight) + topMultiplier);

        var imageUrl = imageList[i].file_path;
        fabric.Image.fromURL(
          imageUrl,
          function (img) {

            /*
            img.scaleToWidth(imgWidth);
            img.scaleToHeight(imgHeight);
            */


            const scaleX = pdfWidth / img.width;
            const scaleY = pdfHeight / img.height;
            const scale = Math.min(scaleX, scaleY);

            img.scale(scale);

            const imgWidth = img.width * scale;
            const left = (pdfWidth - imgWidth) / 2;

            img.set({
              left: left,
              hasControls: false,
              selectable: false,
              hoverCursor: "default",
              objectCaching: true,
            });

            canvas.add(img).renderAll();
          },
          {
            id: "page_" + (i + 1),
            num: 0,
            left: 0,
            top: top,
            hasControls: false,
            selectable: false,
            hoverCursor: "default",
            objectCaching: true,
          }
        );

        let objArr = {
          object_id: "page_" + (i + 1),
          position: { left: 0, top: top, width: pdfWidth, height: pdfHeight },
        };
        pagePositionArr.push(objArr);
      }

      //Update the page position
      let pagesPosition = localStorage.getItem("pagesPosition");
      if (pagesPosition === null) {
        localStorage.setItem("pagesPosition", JSON.stringify(pagePositionArr));
      }

      setTimeout(function () {
        autoFillEditModeRef.current?.click();
      }, 3000);

      //dragging cordinate store in localStorage
      canvas.on("dragover", function (options) {
        // Get pointer coordinates
        const pointer = canvas.getPointer(options.e);
        const x = pointer.x;
        const y = pointer.y;

        storeMousePosition(x, y);
      });
    }
  }, [makeFillable, imageList, canvas, pdfDimensions]);

  useEffect(() => {
    renderImageOnCanvas();
  }, [renderImageOnCanvas, pdfDimensions]);



  useEffect(() => {
    //Set mode
    let row = formObj.sign_documents.find(
      (x) => parseInt(x.id) === parseInt(signDocId)
    );

    if (row !== undefined) {
      let mode = row ? parseInt(row.mode) : 1;

      let recipients = "";
      if (mode === 1) {
        let recipientObj = EVERY_ONE_OBJECT;
        let backgoundColorEveryOne = "d1ecf1";
        recipientObj.image = generateOptionImage(backgoundColorEveryOne, "Everyone");
        recipientObj.color_code = backgoundColorEveryOne;
        recipients = [recipientObj];
      } else {
        recipients = [];
      }


      //let bg = generateRandomColors(formObj.recipient_List.length);
      for (let i = 0; i < formObj.recipient_List.length; i++) {
        let fullName = formObj.recipient_List[i]["first_name"] + " " + formObj.recipient_List[i]["last_name"];
        let bg = generateColorCode(fullName, 0.5);

        recipients.push({
          value: formObj.recipient_List[i]["id"],
          label: fullName,
          image: generateOptionImage(bg, formObj.recipient_List[i]["first_name"]),
          color_code: bg
        });
      }

      setDocRecipients(recipients);
    }
  }, [formObj, signDocId]);


  const fillImageList = useCallback(async () => {
    if (signatureDocumentData?.id) {

      setSignDocMode(parseInt(signatureDocumentData?.mode));

      // Update the sign mode wise request sign
      if (parseInt(signatureDocumentData?.mode) === 2) {
        setRequestSign([]);
      }

      let obj = {
        signature_document_id: signatureDocumentData?.id,
      };

      getEnvelopeRequestSignDocumentPages(obj)
        .then((response) => {
          setSignDocId(signatureDocumentData?.id);
          setImageList(response.data.data);

          // Fill recipients on single sign mode.

          if (
            signatureDocumentData.request_id !== "" &&
            signatureDocumentData.mode === 1
          ) {
            let selectedObj = [];
            let recipients = signatureDocumentData.request_id.split(",");
            for (let i = 0; i < recipients.length; i++) {
              let index = docRecipients.findIndex(
                (x) => parseInt(x.value) === parseInt(recipients[i])
              );
              if (index > -1) {
                selectedObj.push({
                  value: docRecipients[index]["value"],
                  label: docRecipients[index]["label"],
                });
              }
            }
            setRequestSign(selectedObj);
          }

          /*else{
            if(signatureDocumentData.mode === 1){
              setRequestSign([EVERY_ONE_OBJECT]);
            }
          }*/

        })
        .catch((err) => { });
    }
  }, [signatureDocumentData, docRecipients]);

  useEffect(
    function () {
      if (makeFillable === true) {
        // Only set default selection if we're in edit mode (existing document)
        if (signatureDocumentData?.request_id && signatureDocumentData?.request_id !== "") {
          setRequestSign([EVERY_ONE_OBJECT]);
        } else {
          // For new documents, don't set any default selection
          setRequestSign([]);
        }

        fillImageList();

        // Set visibleFabricTools to true immediately when opening in edit mode
        // This ensures the Signature Fields and Auto-fill Fields sections are shown
        if (signatureDocumentData?.request_id && signatureDocumentData?.request_id !== "") {
          setVisibleFabricTools(true);
        }

        setTimeout(function () {
          setLoading(false);
        }, 3000);
      }
    },
    [makeFillable, setLoading, fillImageList, signatureDocumentData]
  );


  useEffect(function () {
    // Only set visibleFabricTools based on signDocMode if we're not in edit mode
    // In edit mode, we want to keep the tools visible regardless of mode
    if (signatureDocumentData?.request_id && signatureDocumentData?.request_id !== "") {
      // We're in edit mode, keep tools visible
      setVisibleFabricTools(true);
    } else {
      // We're in create mode, set based on signDocMode
      if (signDocMode === 1 || signDocMode === 2) {
        setVisibleFabricTools(true);
      } else {
        setVisibleFabricTools(false);
      }
    }
    setNoFieldSelectionFlag(true);
  }, [signDocMode, signatureDocumentData]);

  // Ensure canvas events are properly set up when canvas is ready
  useEffect(() => {
    if (canvas && makeFillable) {
      // Remove existing event listeners to avoid duplicates
      canvas.off("object:moving", objectMovedListener);
      canvas.off("mouse:up", mouseUpListener);
      canvas.off("object:added", objectAddedListener);
      canvas.off("selection:created", renderRightSidebar);
      canvas.off("selection:cleared", renderRightSidebar);

      // Add event listeners
      canvas.on("object:moving", objectMovedListener);
      canvas.on("mouse:up", mouseUpListener);
      canvas.on("object:added", objectAddedListener);
      canvas.on("selection:created", renderRightSidebar);
      canvas.on("selection:cleared", renderRightSidebar);
      canvas.on("mouse:down", function (e) {
        console.log("Mouse down event:", e.target);
        if (e.target && (e.target.id.indexOf("sign") > -1 || e.target.id.indexOf("textbox") > -1)) {
          console.log("Clicked on field:", e.target.id);
          // Force selection of the object
          canvas.setActiveObject(e.target);
          canvas.renderAll();
          renderRightSidebar();

          // Prevent the object from being deselected immediately
          setTimeout(() => {
            if (canvas.getActiveObject() !== e.target) {
              console.log("Object was deselected, reselecting:", e.target.id);
              canvas.setActiveObject(e.target);
              canvas.renderAll();
            }
          }, 10);
        }
      });

      // Prevent accidental deletion by checking if it's a control click
      canvas.on("mouse:down", function (e) {
        if (e.target && e.target.id) {
          console.log("Mouse down on object:", e.target.id, "Event:", e.e);
          // Check if this is a control click (delete button)
          if (e.e && e.e.target && e.e.target.className && e.e.target.className.includes('delete')) {
            console.log("Delete control clicked - allowing deletion");
          } else {
            console.log("Regular object click - preventing accidental deletion");
          }
        }
      });

      // Also handle object selection events
      canvas.on("selection:created", function (e) {
        console.log("Selection created:", e.selected);
        renderRightSidebar();
      });

      canvas.on("selection:updated", function (e) {
        console.log("Selection updated:", e.selected);
        renderRightSidebar();
      });

      // Add mouse:up event to handle selection
      canvas.on("mouse:up", function (e) {
        console.log("Mouse up event:", e.target);
        if (e.target && (e.target.id.indexOf("sign") > -1 || e.target.id.indexOf("textbox") > -1)) {
          console.log("Mouse up on field:", e.target.id);
          renderRightSidebar();
        }
      });
    }
  }, [canvas, makeFillable]);



  function generateColorCode(name, opacity) {
    // DJB2 hashing algorithm
    let hash = 5381;
    for (let i = 0; i < name.length; i++) {
      hash = (hash * 33) ^ name.charCodeAt(i);
    }
    const hashCode = (hash >>> 0).toString(16);

    // Use the first 6 characters of the hash code as the color code
    const colorCode = hashCode.slice(0, 6).padStart(6, '0');

    // Add opacity to the color
    const alpha = Math.round(opacity * 255).toString(16).padStart(2, '0');
    const colorWithAlpha = colorCode + alpha; // Append alpha channel to the color code

    return colorWithAlpha;
  }


  function generateOptionImage(background, name) {
    let firstChar = name.charAt(0).toUpperCase() + name.slice(1);
    return "https://ui-avatars.com/api/?name=" + firstChar + "&background=" + background + "&color=000&rounded=true&bold=true&uppercase=true&length=2";
  }


  // function saveForm(e) {
  //   e.preventDefault();
  //   setErrors(errorsObj);
  //   setLoading(true);

  //   let error = false;
  //   const errorObj = { ...errors };
  //   const envelopeFormData = formObj;

  //   // Skip recipient validation for preview redirect
  //   let placeholdersUpdated = localStorage.getItem("placeholders");
  //   let placeholders = JSON.parse(placeholdersUpdated);

  //   if (placeholders === null) {
  //     setLoading(false);
  //     toast.error("Please add placeholder on the page.");
  //     error = true;
  //   }

  //   // Get local page position
  //   let pagesPosition = localStorage.getItem("pagesPosition");
  //   pagesPosition = JSON.parse(pagesPosition);
  //   if (pagesPosition === null) {
  //     setLoading(false);
  //     toast.error("Pages position is not updated.");
  //     error = true;
  //   }

  //   if (error) {
  //     // If error occurs, redirect to preview mode directly
  //     setLoading(false);
  //     renderPreviewTool(true); // Trigger preview mode
  //     setPreviewButtonText("Turn Off Preview");
  //     const container = containerRef.current;
  //     if (container) {
  //       container.style.boxShadow = '0 1rem 3rem rgba(0,0,0,.175)';
  //     }
  //     return;
  //   }

  //   let recipientValue = requestSign.length > 0 ? requestSign : []; // Default to empty array if no recipients

  //   let obj = {
  //     envelope_id: envelopeFormData.envelope_id,
  //     mode: signDocMode,
  //     signature_document_id: signDocId,
  //     request_form: recipientValue,
  //     pages_position: pagesPosition,
  //     items: placeholders,
  //   };

  //   signPlaceholdersUpdate(obj)
  //     .then((response) => {
  //       let requestId = response.data.data.request_id;
  //       let requestDisplay = [];
  //       if (requestSign.length !== 0) {
  //         let recipients = requestId.split(",");
  //         for (let i = 0; i < recipients.length; i++) {
  //           let index = envelopeFormData.recipient_List.findIndex(
  //             (x) => parseInt(x.id) === parseInt(recipients[i])
  //           );
  //           if (index > -1) {
  //             let firstName = envelopeFormData.recipient_List[index]["first_name"];
  //             let lastName = envelopeFormData.recipient_List[index]["last_name"];
  //             let firstLetter = firstName.charAt(0);
  //             let lastLetter = lastName.charAt(0);
  //             requestDisplay.push({
  //               full_name: firstName + " " + lastName,
  //               display: firstLetter + lastLetter,
  //             });
  //           }
  //         }
  //       }

  //       let index = envelopeFormData.sign_documents.findIndex(
  //         (x) => parseInt(x.id) === parseInt(signDocId)
  //       );
  //       if (index > -1) {
  //         envelopeFormData.sign_documents[index]["request_id"] = requestId;
  //         envelopeFormData.sign_documents[index]["request_display"] = requestDisplay;
  //       }

  //       setFormObj(envelopeFormData);
  //       setLoading(false);
  //       toast.success(response.data.message);
  //       clearForm(e);
  //       clsFormButtonRef.current?.click();
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //       toast.error(Utils.getErrorMessage(err));
  //       // Redirect to preview mode on error
  //       renderPreviewTool(true);
  //       setPreviewButtonText("Turn Off Preview");
  //       const container = containerRef.current;
  //       if (container) {
  //         container.style.boxShadow = '0 1rem 3rem rgba(0,0,0,.175)';
  //       }
  //     });
  // }


  function saveForm(e) {
    e.preventDefault();
    setErrors(errorsObj);
    setLoading(true);

    // Validate placeholders
    let placeholdersUpdated = localStorage.getItem("placeholders");
    let placeholders = placeholdersUpdated ? JSON.parse(placeholdersUpdated) : null;

    if (!placeholders || placeholders.length === 0) {
      setLoading(false);
      toast.error("Please add at least one signature field");
      return;
    }

    // Get page positions
    let pagesPosition = localStorage.getItem("pagesPosition");
    pagesPosition = pagesPosition ? JSON.parse(pagesPosition) : null;

    if (!pagesPosition) {
      setLoading(false);
      toast.error("Document layout information is missing");
      return;
    }

    // Prepare recipient data based on signing mode
    let recipientValue = [];

    if (signDocMode === 1) {
      // Individual signing mode
      if (requestSign.length === 0) {
        setLoading(false);
        toast.error("Please select at least one recipient");
        return;
      }

      // Handle "Everyone" selection
      if (requestSign.some(r => r.value === 0)) {
        // Include all recipients
        recipientValue = formObj.recipient_List.map(recipient => ({
          value: recipient.id,
          label: `${recipient.first_name} ${recipient.last_name}`
        }));
      } else {
        // Use selected recipients
        recipientValue = requestSign;
      }
    } else if (signDocMode === 2) {
      // Group signing mode
      const uniqueRecipients = [...new Set(placeholders
        .filter(p => !p.is_deleted && p.request_recipient)
        .map(p => p.request_recipient.value))];

      if (uniqueRecipients.length === 0) {
        setLoading(false);
        toast.error("No recipients assigned to signature fields");
        return;
      }

      recipientValue = docRecipients.filter(r =>
        uniqueRecipients.includes(r.value)
      );
    }

    let obj = {
      envelope_id: formObj.envelope_id,
      mode: signDocMode,
      signature_document_id: signDocId,
      request_form: recipientValue,
      pages_position: pagesPosition,
      items: placeholders.filter(p => !p.is_deleted),
    };

    signPlaceholdersUpdate(obj)
      .then((response) => {
        // Update request display information
        let requestDisplay = recipientValue.map(recipient => {
          const recipientData = formObj.recipient_List.find(
            r => r.id === recipient.value
          ) || { first_name: "", last_name: "" };

          return {
            full_name: `${recipientData.first_name} ${recipientData.last_name}`,
            display: `${recipientData.first_name.charAt(0)}${recipientData.last_name.charAt(0)}`
          };
        });

        // Update form state
        const updatedForm = { ...formObj };
        const docIndex = updatedForm.sign_documents.findIndex(
          x => parseInt(x.id) === parseInt(signDocId)
        );

        if (docIndex > -1) {
          updatedForm.sign_documents[docIndex] = {
            ...updatedForm.sign_documents[docIndex],
            request_id: recipientValue.map(r => r.value).join(","),
            request_display: requestDisplay
          };
        }

        setFormObj(updatedForm);
        setLoading(false);
        toast.success(response.data.message);
        clearForm(e);
        clsFormButtonRef.current?.click();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(Utils.getErrorMessage(err));
      });
  }
  function clearForm(e) {
    e.preventDefault();

    setImageList([]);
    setRequestSign("");
    setVisibleFabricTools(false);
    setNoFieldSelectionFlag(true);

    // Reset animation state
    setShowAnimation(false);
    setAnimationCount(0);

    handleMakeFillable(); //Update the flag of popup handle

    clearLocalStorage();
    canvas.clear();
    console.log("Clear...");
  }

  function clearLocalStorage() {
    localStorage.removeItem("mousePosition");
    localStorage.removeItem("pagesPosition");
    localStorage.removeItem("placeholders");
  }

  function objectMovedListener(ev) {
    let target = ev.target;
    let object_id = target.id;
    if (object_id.indexOf("sign") > -1 || object_id.indexOf("textbox") > -1) {
      mapObjectInPage(target);
    }
  }

  function mapObjectInPage(target) {
    var placeholdersUpdated = localStorage.getItem("placeholders");
    var placeholdersArr = JSON.parse(placeholdersUpdated);

    if (placeholdersArr != null) {
      var objIndex = placeholdersArr.findIndex(
        (obj) => obj.object_id === target.id
      );
    }

    var items = canvas.getObjects().filter(function (o) {
      return o.id.indexOf("page") > -1;
    });

    var intersectPageObjectId = "";
    for (var i = 0, n = items.length; i < n; i++) {
      var m = items[i];

      if (target.intersectsWithObject(m)) {
        intersectPageObjectId = m.id;
      }
    }

    //Update the page object id in sign object array
    if (placeholdersArr != null) {
      if (intersectPageObjectId !== "" && objIndex >= 0) {
        placeholdersArr[objIndex].page_object_id = intersectPageObjectId;
        localStorage.setItem("placeholders", JSON.stringify(placeholdersArr));
      }
    }
  }

  function mouseUpListener(ev) {
    let target = ev.target;
    let object_id = target.id;
    if (object_id.indexOf("sign") > -1 || object_id.indexOf("textbox") > -1) {
      storeObjectInLocal(target);
      renderRightSidebar();
    }
  }

  function renderRightSidebar() {
    var activeObject = canvas.getActiveObject();
    console.log("Active object:", activeObject); // Debug log
    console.log("Canvas objects:", canvas.getObjects()); // Debug log
    if (activeObject !== null) {
      let objectId = activeObject.id;
      console.log("Object ID:", objectId); // Debug log

      // Visible date format in right side bar
      if (objectId.indexOf("date") > -1) {
        setVisibleDateFormatDropdown(true);
      } else {
        setVisibleDateFormatDropdown(false);
      }

      // Visible date format in right side bar
      if (objectId.indexOf("static") > -1) {
        setVisibleTextContentTextarea(true);
      } else {
        setVisibleTextContentTextarea(false);
      }

      //Assign to dropdown hide and show
      if ((signDocMode === 2) && (objectId.indexOf("static") === -1)) {
        setAssignToRecipient(activeObject.requestRecipient);
        setVisibleAssignToDropdown(true);
      } else {
        setVisibleAssignToDropdown(false);
      }



      // get exiting filled value from local storage
      var placeholdersUpdated = localStorage.getItem("placeholders");
      var placeholdersArr = placeholdersUpdated ? JSON.parse(placeholdersUpdated) : [];

      var objIndex = placeholdersArr.findIndex(
        (obj) => obj.object_id === objectId
      );

      if (objIndex >= 0) {
        var dateFormat = placeholdersArr[objIndex].date_format;
        var textContent = placeholdersArr[objIndex].text_content;
        var textFontFamily = placeholdersArr[objIndex].text_font_family;
        var textFontSize = placeholdersArr[objIndex].text_font_size;

        var selectedFontFamilyOption = FONT_FAMILY_LIST.find(option => option.value === textFontFamily);
        var selectedFontSizeOption = FONT_SIZE_LIST.find(option => option.value === textFontSize);

        setSelectedFont(selectedFontFamilyOption);
        setSelectedFontSize(selectedFontSizeOption);

        if (objectId.indexOf("date") > -1) {
          var selectedDateFormatOption = DATEFORMAT_LIST.find(option => option.value === dateFormat);
          setSelectedDateFormat(selectedDateFormatOption);
        }

        if (objectId.indexOf("static") > -1) {
          setSelectedTextContent(textContent);
        }

        setNoFieldSelectionFlag(false);
      } else {
        setNoFieldSelectionFlag(true);
      }
    } else {
      setNoFieldSelectionFlag(true);
    }
  }

  function objectAddedListener(ev) {
    //Call on every new object added by user
    let target = ev.target;
    let object_id = target.id;
    if (object_id.indexOf("sign") > -1 || object_id.indexOf("textbox") > -1) {
      storeObjectInLocal(ev.target);
      mapObjectInPage(ev.target);
    }
  }

  function storeObjectInLocal(target) {
    var objectId = target.id;
    //console.log("Call object store " + objectId);
    var objBox = target.getBoundingRect();

    //let textContent = "";
    let colorCode = getBackgroundColor(target);
    let textContent = getLabelFromTextBoxPlaceholder(target);
    let requestRecipient = getRequestRecipient(target);

    let dateFormat = "";
    if (objectId.indexOf("date") > -1) {
      dateFormat = "DD/MM/YYYY";
    }


    var placeholders = localStorage.getItem("placeholders");
    if (placeholders == null) {
      //Empty
      let placeholdersArr = [];
      let objArr = {
        object_id: objectId,
        mode: signDocMode,
        request_recipient: requestRecipient,
        position: objBox,
        page_object_id: "",
        text_content: textContent,
        text_font_size: "14",
        text_font_family: 'Arial',
        date_format: dateFormat,
        is_deleted: false,
        color_code: colorCode
      };
      placeholdersArr.push(objArr);
      localStorage.setItem("placeholders", JSON.stringify(placeholdersArr));
    } else {
      //Not Empty
      var placeholdersUpdated = localStorage.getItem("placeholders");
      var placeholdersArr = JSON.parse(placeholdersUpdated);

      var objIndex = placeholdersArr.findIndex(
        (obj) => obj.object_id === objectId
      );
      if (objIndex < 0) {
        //New Entry
        let objArr = {
          object_id: objectId,
          mode: signDocMode,
          request_recipient: requestRecipient,
          page_object_id: "",
          position: objBox,
          is_deleted: false,
          text_content: textContent,
          text_font_size: "14",
          text_font_family: 'Arial',
          date_format: dateFormat,
          color_code: colorCode
        };
        placeholdersArr.push(objArr);
      } else {
        //Update exiting entry
        placeholdersArr[objIndex].position = objBox;
        placeholdersArr[objIndex].text_content = textContent;
        placeholdersArr[objIndex].request_recipient = requestRecipient;
        placeholdersArr[objIndex].color_code = colorCode;
      }
      localStorage.setItem("placeholders", JSON.stringify(placeholdersArr));
    }
  }

  function getLabelFromTextBoxPlaceholder(target) {
    let groupObjects = target._objects;
    let objectText = findObjectByKey(groupObjects, "text");
    let text = objectText.text;
    return text;
  }

  function getRequestRecipient(target) {
    return (target.requestRecipient) ? target.requestRecipient : '';
  }

  function getBackgroundColor(target) {
    return (target.backgroundColor) ? target.backgroundColor : '';
  }




  function deleteObject(eventData, transform) {
    var target = transform.target;
    var canvas = target.canvas;
    console.log("Deleting object:", target.id); // Debug log

    // Only delete if this is actually a delete control click
    if (eventData && eventData.e && eventData.e.target && eventData.e.target.className && eventData.e.target.className.includes('delete')) {
      console.log("Confirmed delete control click - proceeding with deletion");
      updateDeleteFlagInSignObject(target);
      canvas.remove(target);
      canvas.requestRenderAll();
    } else {
      console.log("Not a delete control click - preventing deletion");
    }
  }

  function updateDeleteFlagInSignObject(target) {
    var objectId = target.id;
    var placeholdersUpdated = localStorage.getItem("placeholders");
    var placeholdersArr = JSON.parse(placeholdersUpdated);

    var objIndex = placeholdersArr.findIndex(
      (obj) => obj.object_id === objectId
    );
    placeholdersArr[objIndex].is_deleted = true;
    placeholdersArr[objIndex].page_object_id = "";

    localStorage.setItem("placeholders", JSON.stringify(placeholdersArr));
  }

  function renderIcon(ctx, left, top, styleOverride, fabricObject) {
    var size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(img, -size / 2, -size / 2, size, size);
    ctx.restore();
  }

  function generateId(type) {
    return `${type}-${Math.random().toString(36).substr(2, 9)}`;
  }


  function createTextLabel(
    textContent,
    fontSize,
    fontFamily,
    textColor,
    originX,
    originY,
    textLeft,
    textTop,
    previewMode
  ) {
    try {
      // Default to Arial if font fails to load or is not available
      const effectiveFontFamily = (fontFamily === "Playball" && !fontLoaded) ? "Arial" : fontFamily;

      return new fabric.Text(textContent || "", {  // Ensure textContent has fallback
        fontSize: fontSize || 14,                 // Default font size
        fontFamily: effectiveFontFamily,
        fill: textColor || "#000000",             // Default text color
        originX: originX || "left",
        originY: originY || "top",
        left: textLeft || 0,
        top: textTop || 0,
        objectCaching: true,
      });
    } catch (error) {
      console.error("Error creating text label:", error);
      // Return a minimal valid text object as fallback
      return new fabric.Text("", {
        fontSize: 14,
        fontFamily: "Arial",
        fill: "#000000",
      });
    }
  }
  function createRectangle(objId, imageWidth, imageHeight, fillColor, previewMode) {
    // Ensure valid dimensions
    const rectWidth = Math.max(10, (imageWidth || 150) + 60);  // Minimum width 10
    const rectHeight = Math.max(10, (imageHeight || 50) + 20); // Minimum height 10

    const rectProps = {
      width: rectWidth,
      height: rectHeight,
      radius: 1,
      objectCaching: true,
      hasControls: false,
    };

    if (previewMode) {
      return new fabric.Rect({
        ...rectProps,
        fill: "#FFFFFF",
        stroke: fillColor || "#d1ecf1",  // Default color
        strokeWidth: 3,
        strokeDashArray: [5, 5],
        selectable: false,
      });
    } else {
      return new fabric.Rect({
        ...rectProps,
        fill: fillColor || "#d1ecf1",    // Default color
        stroke: "#ccc",
        strokeWidth: 1,
      });
    }
  }

  function createGroup(
    rect,
    img,
    fTextLabel,
    objId,
    leftPositionObject,
    topPositionObject,
    previewMode
  ) {
    const group = new fabric.Group([rect, img, fTextLabel], {
      id: objId,
      left: leftPositionObject,
      top: topPositionObject,
      lockRotation: true,
      preserveObjectStacking: true,
      selectable: (previewMode) ? false : true,
      hoverCursor: (previewMode) ? "pointer" : "all-scroll",
      objectCaching: true,
    });

    console.log("Created group with ID:", objId, "selectable:", group.selectable, "previewMode:", previewMode); // Debug log

    // Ensure the group is selectable in edit mode
    if (!previewMode) {
      group.set('selectable', true);
      group.set('evented', true);
    }

    return group;
  }

  function createImage(imageURL) {
    //var imageURL = "/images/sign-tool-icon.png"; // Replace with your image URL
    return new Promise((resolve, reject) => {
      fabric.Image.fromURL(imageURL, function (img) {
        if (img) {
          resolve(img);
        } else {
          toast.error("Failed to load the image:");
          reject("Failed to load the image: " + imageURL);
        }
      });
    });
  }

  function fabricTool(
    backgroundColor,
    topPositionObject,
    leftPositionObject,
    widthObject,
    heightObject,
    objId,
    requestRecipient = "",
    fontSize,
    fontFamily,
    textContent = "",
    reRenderRightSidebar = true,
    previewMode = false
  ) {
    /*
    var fontSize = 14;
    var fontFamily = "Arial";
    */
    var originX = "left";
    var originY = "top";
    var textLeft = 15;
    var textTop = 0;
    var fillColor = "#" + backgroundColor;
    var textColor = "#000000"; //"#0c5460";

    var imageURL = "";
    var textLeftPosition = 35;

    // Preview mode set true
    if (!previewMode) {
      if (objId.indexOf("recipient-textbox") > -1) {
        textContent = "Recipient Name";
        imageURL = "/images/recipient-tool-icon.png";
      } else if (objId.indexOf("system-date-textbox") > -1) {
        textContent = "Date Signed";
        imageURL = "/images/calender-tool-icon.png";
      } else if (objId.indexOf("initial-textbox") > -1) {
        textContent = "Initial";
        imageURL = "/images/initial-tool-icon.png";
      } else if (objId.indexOf("email-address-textbox") > -1) {
        textContent = "Email Address";
        imageURL = "/images/email-tool-icon.png";
      } else if (objId.indexOf("sign") > -1) {
        textContent = "Signature";
        imageURL = "/images/sign-tool-icon.png";
      } else {
        textLeftPosition = 10;
        textContent = (textContent === "") ? "Add Content" : textContent;
        fillColor = "#d1ecf1";
      }


      // Add Initial name after label
      if ((requestRecipient !== "") && (objId.indexOf("static") === -1)) {
        textContent = textContent + " (" + getInitial(requestRecipient.label) + ")";
      }
    } else {
      //Need to change the font family on sign & initial
      if ((objId.indexOf("initial-textbox") > -1) || (objId.indexOf("sign") > -1)) {
        fontFamily = "Playball";
      } else if (objId.indexOf("static") > -1) {
        textLeftPosition = 10;
        textContent = (textContent === "") ? "Add Content" : textContent;
        fillColor = "#d1ecf1";
      }
    }

    // Create the Fabric TextLabel
    var fTextLabel = createTextLabel(
      textContent,
      fontSize,
      fontFamily,
      textColor,
      originX,
      originY,
      textLeft,
      textTop,
      previewMode
    );

    createImage(imageURL)
      .then((img) => {
        // Image loaded successfully
        var rect = createRectangle(
          objId,
          fTextLabel.width,
          fTextLabel.height,
          fillColor,
          previewMode
        );

        // Calculate the scale factor to fit the image inside the rectangle
        var scaleFactor = Math.min(20 / img.width, 20 / img.height);

        // Calculate new dimensions for the image
        var newHeight = img.height * scaleFactor;

        // Position the image inside the rectangle
        img.set({
          left: rect.left + 10, // Set image position to the left of the rectangle
          top: 1 + (rect.height - newHeight) / 2, // Center image vertically within the rectangle
          scaleX: scaleFactor, // Set the scale factor for width
          scaleY: scaleFactor, // Set the scale factor for height
          opacity: 0.7, // Set opacity of the image (0.0 to 1.0)
        });

        fTextLabel.set({
          top: (rect.height - fTextLabel.height) / 2,
          left: (previewMode) ? 10 : textLeftPosition
        });
        var group = createGroup(
          rect,
          img,
          fTextLabel,
          objId,
          leftPositionObject,
          topPositionObject,
          previewMode
        );
        // Hide rotating
        group.setControlsVisibility({ mtr: false });

        // Set request recipient in tool
        group.set({
          requestRecipient: requestRecipient, // Ensure this is set for all sign/initial fields
          backgroundColor: backgroundColor,
        });

        // Add the group to the canvas
        canvas.add(group);

        if (!previewMode) {
          canvas.setActiveObject(group);
          console.log("Set active object:", group.id); // Debug log
        }

        // Render canvas
        canvas.renderAll();
        console.log("Added group to canvas:", group.id, "selectable:", group.selectable); // Debug log

        if (reRenderRightSidebar) {
          //Render right sidebar as per tool
          setSelectedFont(FONT_FAMILY_LIST[0]);
          setSelectedFontSize(FONT_SIZE_LIST[0]);
          setSelectedDateFormat(DATEFORMAT_LIST[0]);
          setSelectedTextContent('');
          renderRightSidebar();

        }

      })
      .catch((error) => {
        console.log(error);
        // Image loading failed
        toast.error("Failed to load the image:");
      });
  }




  function handelAutoFillEditMode() {
    var placeholdersUpdatedCheck = localStorage.getItem("placeholders");
    if (placeholdersUpdatedCheck === null) {
      for (var i = 0; i < imageList.length; i++) {
        var placeholderDetails = imageList[i].placeholder_details;
        if (placeholderDetails !== null) {
          let items = placeholderDetails.items;
          if (items.length > 0) {
            var placeholdersUpdated = localStorage.getItem("placeholders");
            var placeholdersArr =
              JSON.parse(placeholdersUpdated) == null
                ? []
                : JSON.parse(placeholdersUpdated);
            for (let j = 0; j < items.length; j++) {
              let objPlaceholder = items[j];
              let objectId = objPlaceholder.object_id;

              let foundObject = placeholdersArr.find(
                (obj) => obj.object_id === objectId
              );
              if (foundObject === undefined) {
                placeholdersArr.push(objPlaceholder);
              }
            }
            localStorage.setItem(
              "placeholders",
              JSON.stringify(placeholdersArr)
            );
          }
        }


        //Render fabric object on canvas
        if (placeholderDetails !== null) {
          let items = placeholderDetails.items;
          for (let j = 0; j < items.length; j++) {
            let item = items[j];
            let objId = item.object_id;
            let backgroundColor = item.color_code;
            let topPositionObject = item.position.top;
            let leftPositionObject = item.position.left;
            let widthObject = item.position.width;
            let heightObject = item.position.height;
            let requestRecipient = item.request_recipient;
            let textContent = item.text_content;
            let fontSize = item.text_font_size;
            let fontFamily = item.text_font_family;
            let reRenderRightSidebar = false;

            // Regererate the fabric tool on canvas
            console.log("Creating fabric tool for existing field:", objId); // Debug log
            fabricTool(
              backgroundColor,
              topPositionObject,
              leftPositionObject,
              widthObject,
              heightObject,
              objId,
              requestRecipient,
              fontSize,
              fontFamily,
              textContent,
              reRenderRightSidebar,
              false // previewMode = false for edit mode
            );

            // Ensure the object is properly selectable after creation
            setTimeout(() => {
              const objects = canvas.getObjects();
              const targetObject = objects.find(obj => obj.id === objId);
              if (targetObject) {
                targetObject.set('selectable', true);
                targetObject.set('evented', true);
                targetObject.set('hoverCursor', 'all-scroll');
                canvas.renderAll();
                console.log("Made object selectable:", objId);
              }
            }, 100);
          }
        }


      }

      // In edit mode, always show the tools regardless of signDocMode
      if (signatureDocumentData?.request_id && signatureDocumentData?.request_id !== "") {
        setVisibleFabricTools(true);
      } else {
        // Only set based on signDocMode if not in edit mode
        if (signDocMode === 1 || signDocMode === 2) {
          setVisibleFabricTools(true);
        } else {
          setVisibleFabricTools(false);
        }
      }

      // Ensure all objects are selectable after loading
      setTimeout(() => {
        if (canvas) {
          const objects = canvas.getObjects();
          objects.forEach(obj => {
            if (obj.id && (obj.id.indexOf("sign") > -1 || obj.id.indexOf("textbox") > -1)) {
              obj.set('selectable', true);
              obj.set('evented', true);
              obj.set('hoverCursor', 'all-scroll');
            }
          });
          canvas.renderAll();
          console.log("Made all existing objects selectable");
        }
      }, 500);
    }
  }



  // Function to find an object with a specific key
  function findObjectByKey(objects, keyToFind) {
    // Iterate over each object in the array
    for (const obj of objects) {
      // Check if the object has the specified key
      if (obj.hasOwnProperty(keyToFind)) {
        // Return the object if the key is found
        return obj;
      }
    }
    // Return null if the key is not found in any object
    return null;
  }

  function toolFontChange(selectedOption) {
    var activeObject = canvas.getActiveObject();
    if (activeObject !== null) {

      let objectId = activeObject.id;
      setSelectedFont(selectedOption);

      var placeholdersUpdated = localStorage.getItem("placeholders");
      var placeholdersArr = JSON.parse(placeholdersUpdated);

      var objIndex = placeholdersArr.findIndex(
        (obj) => obj.object_id === objectId
      );

      // Update exiting entry
      placeholdersArr[objIndex].text_font_family = selectedOption.value;
      localStorage.setItem("placeholders", JSON.stringify(placeholdersArr));

      // Update the fabric canvas object
      var objectWithKey = findObjectByKey(activeObject._objects, "text");
      objectWithKey.set("fontFamily", selectedOption.value);
      canvas.renderAll();

    } else {
      toast.error("Please select specific tool.");
    }
  }

  function toolFontSizeChange(selectedOption) {
    var activeObject = canvas.getActiveObject();
    if (activeObject !== null) {

      let objectId = activeObject.id;
      setSelectedFontSize(selectedOption);

      var placeholdersUpdated = localStorage.getItem("placeholders");
      var placeholdersArr = JSON.parse(placeholdersUpdated);

      var objIndex = placeholdersArr.findIndex(
        (obj) => obj.object_id === objectId
      );

      // Remove active object
      updateDeleteFlagInSignObject(activeObject);
      canvas.remove(activeObject);
      canvas.requestRenderAll();

      // Update exiting entry
      placeholdersArr[objIndex].text_font_size = selectedOption.value;
      placeholdersArr[objIndex].is_deleted = false;
      localStorage.setItem("placeholders", JSON.stringify(placeholdersArr));


      // Re render fabric tool on canvas
      let backgroundColor = placeholdersArr[objIndex].color_code;
      let topPositionObject = placeholdersArr[objIndex].position.top;
      let leftPositionObject = placeholdersArr[objIndex].position.left;
      let widthObject = placeholdersArr[objIndex].position.width;
      let heightObject = placeholdersArr[objIndex].position.height;
      let objId = placeholdersArr[objIndex].object_id;
      let requestRecipient = placeholdersArr[objIndex].request_recipient;
      let fontSize = placeholdersArr[objIndex].text_font_size;
      let fontFamily = placeholdersArr[objIndex].text_font_family;
      let textContent = placeholdersArr[objIndex].text_content;
      let reRenderRightSidebar = false;

      fabricTool(
        backgroundColor,
        topPositionObject,
        leftPositionObject,
        widthObject,
        heightObject,
        objId,
        requestRecipient,
        fontSize,
        fontFamily,
        textContent,
        reRenderRightSidebar
      );
    } else {
      toast.error("Please select specific tool.");
    }
  }


  function toolDateFormatChange(selectedOption) {
    var activeObject = canvas.getActiveObject();
    if (activeObject !== null) {

      let objectId = activeObject.id;
      setSelectedDateFormat(selectedOption);

      var placeholdersUpdated = localStorage.getItem("placeholders");
      var placeholdersArr = JSON.parse(placeholdersUpdated);

      var objIndex = placeholdersArr.findIndex(
        (obj) => obj.object_id === objectId
      );

      // Update exiting entry
      placeholdersArr[objIndex].date_format = selectedOption.value;
      localStorage.setItem("placeholders", JSON.stringify(placeholdersArr));

    } else {
      toast.error("Please select specific tool.");
    }
  }

  function toolTextContentChange(event) {
    var textContent = event.target.value;
    var activeObject = canvas.getActiveObject();
    if (activeObject !== null) {

      let objectId = activeObject.id;
      setSelectedTextContent(textContent);

      var placeholdersUpdated = localStorage.getItem("placeholders");
      var placeholdersArr = JSON.parse(placeholdersUpdated);

      var objIndex = placeholdersArr.findIndex(
        (obj) => obj.object_id === objectId
      );

      if (objIndex !== -1) {
        // Update the text content in localStorage first
        placeholdersArr[objIndex].text_content = textContent;
        placeholdersArr[objIndex].is_deleted = false;
        localStorage.setItem("placeholders", JSON.stringify(placeholdersArr));

        // Update the active object's text directly instead of recreating it
        if (activeObject.type === 'group') {
          // If it's a group, find the text object within it
          const textObject = activeObject.getObjects().find(obj => obj.type === 'text');
          if (textObject) {
            textObject.set('text', textContent);
            activeObject.setCoords();
          }
        } else if (activeObject.type === 'text') {
          // If it's a direct text object
          activeObject.set('text', textContent);
        }

        // Force canvas to re-render
        canvas.requestRenderAll();
      }

    } else {
      toast.error("Please select specific tool.");
    }
  }



  function changeRecipientOnSingleSignMode(options) {
    console.log("Selected options:", options); // Debug log
    let checkEveryone = options.findIndex((x) => parseFloat(x.value) === 0);
    console.log("Check everyone result:", checkEveryone); // Debug log

    if (checkEveryone > -1) {
      // If "Everyone" is selected, show it
      console.log("Setting Everyone"); // Debug log
      setRequestSign([EVERY_ONE_OBJECT]);
    } else {
      // If specific recipients are selected, show their actual names
      console.log("Setting specific recipients:", options); // Debug log
      setRequestSign(options);
    }
  }

  function changeRecipientOnMultiSignMode(options) {
    if (options && options.value) {
      setRequestSign([options]);
      setSignerSelectedBackgroundColor(options.color_code);
      setVisibleFabricTools(true);
      setTempRecipient(options);
    } else {
      toast.error("Please select a valid recipient");
    }
  }

  function changeRecipientOnTool(options) {
    setAssignToRecipient(options);
    var activeObject = canvas.getActiveObject();
    if (activeObject !== null) {

      let objectId = activeObject.id;
      var placeholdersUpdated = localStorage.getItem("placeholders");
      var placeholdersArr = JSON.parse(placeholdersUpdated);

      var objIndex = placeholdersArr.findIndex(
        (obj) => obj.object_id === objectId
      );

      // Remove active object
      updateDeleteFlagInSignObject(activeObject);
      canvas.remove(activeObject);
      canvas.requestRenderAll();

      // Update exiting entry
      placeholdersArr[objIndex].color_code = options.color_code;
      placeholdersArr[objIndex].request_recipient = options; // Update the selected request recipients
      placeholdersArr[objIndex].is_deleted = false;
      localStorage.setItem("placeholders", JSON.stringify(placeholdersArr));

      // Re render fabric tool on canvas
      let backgroundColor = options.color_code;
      let topPositionObject = placeholdersArr[objIndex].position.top;
      let leftPositionObject = placeholdersArr[objIndex].position.left;
      let widthObject = placeholdersArr[objIndex].position.width;
      let heightObject = placeholdersArr[objIndex].position.height;
      let objId = placeholdersArr[objIndex].object_id;
      let requestRecipient = placeholdersArr[objIndex].request_recipient;
      let textContent = placeholdersArr[objIndex].text_content;
      let fontSize = placeholdersArr[objIndex].text_font_size;
      let fontFamily = placeholdersArr[objIndex].text_font_family;
      let reRenderRightSidebar = false;

      // Regererate the fabric tool on canvas
      fabricTool(
        backgroundColor,
        topPositionObject,
        leftPositionObject,
        widthObject,
        heightObject,
        objId,
        requestRecipient,
        fontSize,
        fontFamily,
        textContent,
        reRenderRightSidebar
      );

    }
  }

  // eslint-disable-next-line
  function togglePreview() {
    // Access all canvas objects
    var items = canvas.getObjects().filter(function (o) {
      return o.id && o.id.indexOf("page") === -1;
    });
    if (items.length === 0) {
      toast.error("Please drag the tools on pdf.");
    } else {
      // Access the DOM element using the ref
      const container = containerRef.current;
      if (previewButtonText === "Preview") {
        setPreviewButtonText("Turn Off Preview");

        // Check if the container exists
        if (container) {
          // Add your styles here
          container.style.boxShadow = '0 1rem 3rem rgba(0,0,0,.175)';
        }

        renderPreviewTool(true);
        setNoFieldSelectionFlag(true);

      } else {
        // Check if the container exists
        if (container) {
          // Add your styles here
          container.style.boxShadow = 'none';
        }

        renderPreviewTool(false);
        setPreviewButtonText("Preview");
      }
    }
  }

  function renderPreviewTool(previewMode) {
    try {
      // Access all canvas objects
      var items = canvas.getObjects().filter(function (o) {
        return o.id && o.id.indexOf("page") === -1;
      });

      // Remove all canvas tool
      items.forEach(function (o) {
        canvas.remove(o);
      });

      // Get canvas object from local machine
      var placeholdersUpdated = localStorage.getItem("placeholders");
      var placeholdersArr = JSON.parse(placeholdersUpdated);

      // Iterate through each element in the array
      placeholdersArr.forEach(function (item) {
        // Perform operations on each item here
        if (item.is_deleted === false) {

          // Re render fabric tool on canvas
          let objId = item.object_id;
          let backgroundColor = item.color_code;
          let topPositionObject = item.position.top;
          let leftPositionObject = item.position.left;
          let widthObject = item.position.width;
          let heightObject = item.position.height;
          let requestRecipient = item.request_recipient;
          let textContent = item.text_content;
          let fontSize = item.text_font_size;
          let fontFamily = item.text_font_family;
          let dateFormat = item.date_format;
          let reRenderRightSidebar = false;


          let recipientList = formObj.recipient_List;
          let recipientId = "";
          if (signDocMode === 1) {
            if (requestSign[0].value === 0) {
              // Get first recipient id
              recipientId = recipientList[0].id;
            } else {
              recipientId = requestSign[0].value;
            }
          } else {
            recipientId = requestRecipient.value;
          }

          if (recipientId) {
            let recipientObject = recipientList.find(
              (obj) => obj.id === recipientId
            );
            if (objId.indexOf("recipient-textbox") > -1) {
              textContent = recipientObject.first_name + " " + recipientObject.last_name;
            } else if (objId.indexOf("system-date-textbox") > -1) {
              textContent = Utils.getCurrentDateByFormat(dateFormat);
            } else if (objId.indexOf("initial-textbox") > -1) {
              textContent = getInitial(recipientObject.first_name + " " + recipientObject.last_name);
            } else if (objId.indexOf("email-address-textbox") > -1) {
              textContent = recipientObject.email;
            } else if (objId.indexOf("sign") > -1) {
              textContent = recipientObject.first_name + " " + recipientObject.last_name;
            }
          }


          // Regererate the fabric tool on canvas
          fabricTool(
            backgroundColor,
            topPositionObject,
            leftPositionObject,
            widthObject,
            heightObject,
            objId,
            requestRecipient,
            fontSize,
            fontFamily,
            textContent,
            reRenderRightSidebar,
            previewMode
          );
        }
      });
    } catch (error) {
      console.error("Error in renderPreviewTool:", error);
      toast.error("Failed to render preview");
      setPreviewButtonText("Preview"); // Reset button if error occurs
    }
  }

  function deleteTool() {
    var activeObject = canvas.getActiveObject();
    if (activeObject !== null) {
      updateDeleteFlagInSignObject(activeObject);
      canvas.remove(activeObject);
      canvas.requestRenderAll();
      setNoFieldSelectionFlag(true);
    } else {
      toast.error("Please select specific tool.");
    }
  }

  function clearTextContent() {
    var activeObject = canvas.getActiveObject();
    if (activeObject !== null) {
      let objectId = activeObject.id;
      setSelectedTextContent("");

      var placeholdersUpdated = localStorage.getItem("placeholders");
      var placeholdersArr = JSON.parse(placeholdersUpdated);

      var objIndex = placeholdersArr.findIndex(
        (obj) => obj.object_id === objectId
      );

      if (objIndex !== -1) {
        // Update the text content in localStorage
        placeholdersArr[objIndex].text_content = "";
        placeholdersArr[objIndex].is_deleted = false;
        localStorage.setItem("placeholders", JSON.stringify(placeholdersArr));

        // Clear the active object's text directly
        if (activeObject.type === 'group') {
          // If it's a group, find the text object within it
          const textObject = activeObject.getObjects().find(obj => obj.type === 'text');
          if (textObject) {
            textObject.set('text', "");
            activeObject.setCoords();
          }
        } else if (activeObject.type === 'text') {
          // If it's a direct text object
          activeObject.set('text', "");
        }

        // Force canvas to re-render
        canvas.requestRenderAll();
      }
    } else {
      toast.error("Please select specific tool.");
    }
  }



  function getInitial(name) {
    if (!name) return "";
    const parts = name.split(" ").filter((part) => part.trim()); // Split name by spaces and filter out empty parts
    if (parts.length === 1) {
      return parts[0].slice(0, 2); // If only one part, return first two characters
    } else {
      return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`; // Otherwise, return first character of first part and first character of last part
    }
  }

  /*
  const Option = (props) => (
    <components.Option
      {...props}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <img
          src={props.data.image}
          alt={props.data.label}
          style={{ marginRight: "7px", width: "30px", height: "30px" }}
        />
        <span>{props.data.label}</span>
      </div>
    </components.Option>
  );
  */

  const formatOptionLabel = ({ label, image }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img src={image} alt={label} style={{ width: '30px', height: '30px', marginRight: '10px' }} />
      <span>{label}</span>
    </div>
  );

  return (
    <>

      <div
        className="offcanvas offcanvas-end makeFillableForm"
        data-bs-scroll="false"
        data-bs-backdrop="static"
        data-bs-keyboard="true"
        tabIndex="-1"
        id="makeFillableForm"
        aria-labelledby="makeFillableFormLabel"
      >
        <div class="arrow-container">
          {/* <img src={arrow} alt="Arrow" class="arrow" /> */}
          <div className="arrow"></div>
        </div>
        <div className="offcanvas-header bg-light border-bottom">
          <h5 className="offcanvas-title fs-4 fw-bold text-primary" id="makeFillableFormLabel">
            {/* Request Document */}
            Document Signing Tool
          </h5>
          <button
            type="button"
            ref={clsFormButtonRef}
            className="btn btn-close close_btn text-reset "
            data-bs-dismiss="offcanvas"
            onClick={clearForm}
            aria-label="Close"
          >
            <i className="bi bi-x-circle" aria-hidden="true" />
          </button>
        </div>
        <div
          className="d-none"
          onClick={handelAutoFillEditMode}
          ref={autoFillEditModeRef}
        ></div>

        <div
          className="offcanvas-body p-0 d-flex flex-column"
          style={{ overflowX: "hidden", }}
        >

          {showAnimation && visibleFabricTools && (
            <div
              className="animated-field"
              style={{
                position: "absolute",
                zIndex: 1000,
                width: "150px",
                height: "40px",
                backgroundColor: `#${signerSelectedBackgroundColor}`,
                color: "white",
                textAlign: "center",
                lineHeight: "40px",
                borderRadius: "5px",
                top: "250px", // Adjust based on the position of "Initial" field in the sidebar
                left: "20px",
                fontSize: "20px"
              }}
            >
              Signature
            </div>
          )}
          <div className="container-fluid h-100">
            <div className="row g-0 h-100">
              {/* Left Tools Panel */}
              <div className="col-md-2 border-end bg-light p-2">
                <div className="d-flex flex-column h-100">
                  {/* Signers Section */}
                  {(signDocMode === 1 || signDocMode === 2) && (
                    <div className="mb-4">
                      <h6 className="fw-bold text-uppercase text-muted mb-3">Signers</h6>
                      <Select
                        closeMenuOnSelect={true}
                        value={requestSign}
                        components={animatedComponents}
                        isMulti={signDocMode === 1}
                        onChange={signDocMode === 1 ? changeRecipientOnSingleSignMode : changeRecipientOnMultiSignMode}
                        options={docRecipients}
                        styles={selectStyles}
                        placeholder="Select signers..."
                        // formatOptionLabel={formatOptionLabel}
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                      {requestSign.length === 0 && (
                        <div className="text-info small mt-2">
                          <i className="bi bi-info-circle me-1"></i>
                          Please select at least one signer to add signature fields
                        </div>
                      )}
                      {errors.recipients && (
                        <div className="text-danger small mt-2">
                          {errors.recipients}
                        </div>
                      )}
                    </div>
                  )}

                  {/* Signature Fields Section */}
                  {visibleFabricTools && (
                    <div className="mb-4">
                      <h6 className="fw-bold text-uppercase text-muted mb-3">Signature Fields</h6>
                      <div className="d-grid gap-2">
                        {['sign', 'initial-textbox'].map((type) => (
                          <button
                            key={type}
                            draggable={requestSign.length > 0}
                            onDragStart={(e) => requestSign.length > 0 ? handleDragStart(e, type) : e.preventDefault()}
                            onDragEnd={handleDragStop}
                            className={`btn text-start d-flex align-items-center py-2 ${requestSign.length > 0 ? 'btn-outline-primary' : 'btn-outline-secondary opacity-50'}`}
                            disabled={requestSign.length === 0}
                          >
                            <div
                              className="rounded-circle d-flex align-items-center justify-content-center me-2"
                              style={{
                                width: '32px',
                                height: '32px',
                                background: `#${signerSelectedBackgroundColor}`,
                              }}
                            >
                              <img
                                src={`/images/${type === 'sign' ? 'sign-tool-icon' : 'initial-tool-icon'}.png`}
                                alt={type}
                                style={{ width: '18px', height: '18px' }}
                              />
                            </div>
                            <span>{type === 'sign' ? 'Signature' : 'Initial'}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Auto-fill Fields Section */}
                  {visibleFabricTools && (
                    <div className="mb-4">
                      <h6 className="fw-bold text-uppercase text-muted mb-3">Auto-fill Fields</h6>
                      <div className="d-grid gap-2">
                        {[
                          { type: 'system-date-textbox', label: 'Date Signed', icon: 'calender-tool-icon' },
                          { type: 'recipient-textbox', label: 'Recipient Name', icon: 'recipient-tool-icon' },
                          { type: 'email-address-textbox', label: 'Email Address', icon: 'email-tool-icon' }
                        ].map((field) => (
                          <button
                            key={field.type}
                            draggable={requestSign.length > 0}
                            onDragStart={(e) => requestSign.length > 0 ? handleDragStart(e, field.type) : e.preventDefault()}
                            onDragEnd={handleDragStop}
                            className={`btn text-start d-flex align-items-center py-2 ${requestSign.length > 0 ? 'btn-outline-secondary' : 'btn-outline-secondary opacity-50'}`}
                            disabled={requestSign.length === 0}
                          >
                            <div
                              className="rounded-circle d-flex align-items-center justify-content-center me-2"
                              style={{
                                width: '32px',
                                height: '32px',
                                background: `#${signerSelectedBackgroundColor}`,
                              }}
                            >
                              <img
                                src={`/images/${field.icon}.png`}
                                alt={field.label}
                                style={{ width: '18px', height: '18px' }}
                              />
                            </div>
                            <span>{field.label}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Add Content Section */}
                  <div className="mt-auto">
                    <button
                      draggable
                      onDragStart={(e) => handleDragStart(e, "static-textbox")}
                      onDragEnd={handleDragStop}
                      className="btn bg-dark-subtle w-100 py-2 d-flex justify-content-center align-items-center"
                    >
                      {/* <i className="bi bi-plus-circle me-2"></i> */}
                      Add Content
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-md-8 bg-light">

                <div className="h-100 d-flex flex-column">
                  <div
                    className="flex-grow-1 position-relative overflow-auto"
                    ref={containerRef}
                  >
                    <div id="canvasRef" className="position-absolute w-100 h-100 d-flex justify-content-center p-4">
                      <canvas
                        id="canv"
                        ref={canvasRef}
                        className=""
                        style={{ border: "none" }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Properties Panel */}
              <div className="col-md-2 border-start bg-light p-3">
                {noFieldSelectionFlag ? (
                  <div className="h-100 d-flex flex-column justify-content-center align-items-center text-center">
                    <div className="mb-3">
                      <img
                        src="/images/signpen.webp"
                        alt="No selection"
                        style={{ width: '64px', opacity: 0.5 }}
                      />
                    </div>
                    <h5 className="fw-bold text-muted mb-2">
                      {signDocMode === 1 ? 'No Field Selected' : 'No Signer Selected'}
                    </h5>
                    <p className="text-muted small">
                      {signDocMode === 1
                        ? 'Select a field to make changes'
                        : 'Please choose the signer'}
                    </p>
                  </div>
                ) : (
                  <div>
                    <div className="d-flex justify-content-center mb-3">
                      <button
                        onClick={deleteTool}
                        className="btn btn-md btn-outline-danger"
                      >
                        <i className="bi bi-trash-alt me-1"></i> Delete
                      </button>
                    </div>

                    {visibleAssignToDropdown && (
                      <div className="mb-4">
                        <h6 className="fw-bold text-uppercase text-muted mb-2">Assigned To</h6>
                        <Select
                          closeMenuOnSelect={true}
                          value={assignToRecipient}
                          onChange={changeRecipientOnTool}
                          options={docRecipients}
                          styles={selectStyles}
                          formatOptionLabel={formatOptionLabel}
                          className="react-select-container"
                          classNamePrefix="react-select"
                        />
                      </div>
                    )}

                    <div className="mb-4">
                      <h6 className="fw-bold text-uppercase text-muted mb-2">Text Properties</h6>
                      <div className="mb-3">
                        <label className="form-label small text-muted">Font Family</label>
                        <Select
                          closeMenuOnSelect={true}
                          value={selectedFont}
                          components={animatedComponents}
                          onChange={toolFontChange}
                          options={FONT_FAMILY_LIST}
                          styles={selectStyles}
                          className="react-select-container"
                          classNamePrefix="react-select"
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label small text-muted">Font Size</label>
                        <Select
                          closeMenuOnSelect={true}
                          value={selectedFontSize}
                          components={animatedComponents}
                          onChange={toolFontSizeChange}
                          options={FONT_SIZE_LIST}
                          styles={selectStyles}
                          className="react-select-container"
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>

                    {visibleDateFormatDropdown && (
                      <div className="mb-4">
                        <h6 className="fw-bold text-uppercase text-muted mb-2">Date Format</h6>
                        <Select
                          closeMenuOnSelect={true}
                          value={selectedDateFormat}
                          components={animatedComponents}
                          onChange={toolDateFormatChange}
                          options={DATEFORMAT_LIST}
                          styles={selectStyles}
                          className="react-select-container"
                          classNamePrefix="react-select"
                        />
                      </div>
                    )}

                    {visibleTextContentTextarea && (
                      <div className="mb-4">
                        <h6 className="fw-bold text-uppercase text-muted mb-2">Enter Content</h6>
                        <textarea
                          className="form-control"
                          value={selectedTextContent}
                          onChange={toolTextContentChange}
                          rows={4}
                          placeholder="Enter content here..."
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Footer Actions */}
          <div className="border-top bg-light p-3">
            <div className="d-flex align-items-end justify-content-end">
              <button
                type="button"
                onClick={togglePreview}
                className="btn btn-outline-primary me-2"
              >
                <i className={`bi bi-eye${previewButtonText === 'Preview' ? '' : '-slash'} me-2`}></i>
                {previewButtonText}
              </button>
              <button
                ref={clsFormButtonRef}
                type="button"
                data-bs-dismiss="offcanvas"
                onClick={clearForm}
                className="btn btn-outline-secondary me-2"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={saveForm}
                className="btn btn-outline-primary"
              >
                <i className="bi bi-save me-2"></i> Save
              </button>

            </div>
          </div>

        </div>

        <style jsx>{`
          .animated-field {
            animation: moveField 4s ease-in-out forwards;
          }
          @keyframes moveField {
            0% {
              transform: translate(0, 0);
              background-color: #007bff;
            }
            50% {
              transform: translate(500px, 100px);
              background-color: #007bff;
            }
            100% {
              transform: translate(500px, 100px);
              background-color: #007bff;
            }
          }
        `}</style>
      </div>
    </>
  );
}

export default MakeFillablePopup;
